import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

export default function MaintenanceDetails(props) {
  const {
    wagonTechnicalDetails,
    nextScheduledRevisionDate,
    classes,
    expanded,
    handleChange,
  } = props;
  const [wagonTechnicalDetailsState, setWagonTechnicalDetailsState] =
    React.useState(null);
  const [nextScheduledRevisionDateState, setNextScheduledRevisionDateState] =
    React.useState('');
  useEffect(() => {
    if (wagonTechnicalDetails !== undefined) {
      setWagonTechnicalDetailsState(wagonTechnicalDetails);
    }
    setNextScheduledRevisionDateState(nextScheduledRevisionDate);
  }, [wagonTechnicalDetails, nextScheduledRevisionDate]);
  const dateFormatter = (date) => {
    return new Intl.DateTimeFormat('en-GB').format(new Date(date));
  };
  const { t } = useTranslation();

  return (
    <div>
      {wagonTechnicalDetailsState && (
        <Accordion
          className={classes.accordion}
          expanded={expanded}
          onChange={handleChange}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          >
            <Typography className={classes.heading}>
              {t('Maintenance details')}
            </Typography>
            <Typography className={classes.secondaryHeading}>
              {t(
                'Find here all details concerning the maintenance of the wagon',
              )}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.container}>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Next scheduled revision date')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Next revision')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Kind of next inspection')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Last maintenance inspection')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel
                    className={
                      nextScheduledRevisionDateState !== null &&
                      nextScheduledRevisionDateState !== ''
                        ? classes.wagonNumberStyle
                        : null
                    }
                  >
                    {nextScheduledRevisionDateState !== null &&
                    nextScheduledRevisionDateState !== ''
                      ? dateFormatter(nextScheduledRevisionDateState)
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.nextRevision !== null &&
                    wagonTechnicalDetailsState.nextRevision !== ''
                      ? dateFormatter(wagonTechnicalDetailsState.nextRevision)
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.kindOfNextInspection !== null &&
                    wagonTechnicalDetailsState.kindOfNextInspection !== ''
                      ? wagonTechnicalDetailsState.kindOfNextInspection
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.lastMainInspection !== null &&
                    wagonTechnicalDetailsState.lastMainInspection !== ''
                      ? dateFormatter(
                          wagonTechnicalDetailsState.lastMainInspection,
                        )
                      : '-'}
                  </FormLabel>
                </Grid>
              </Grid>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Next tank test')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Kind of next tank inspection')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Last tank test')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Construction Year tank')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.nextTankTest !== null &&
                    wagonTechnicalDetailsState.nextTankTest !== ''
                      ? dateFormatter(wagonTechnicalDetailsState.nextTankTest)
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.kindOfNextTankInspection !==
                      null &&
                    wagonTechnicalDetailsState.kindOfNextTankInspection !== ''
                      ? wagonTechnicalDetailsState.kindOfNextTankInspection
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.lastTankTest !== null &&
                    wagonTechnicalDetailsState.lastTankTest !== ''
                      ? dateFormatter(wagonTechnicalDetailsState.lastTankTest)
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.constructionYearTank !== null
                      ? wagonTechnicalDetailsState.constructionYearTank
                      : '-'}
                  </FormLabel>
                </Grid>
              </Grid>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
